import { TS_ItemType } from './TS_ItemType';
import { TS_Item }     from './TS_Item';

export class TS_Coupon extends TS_Item {
    type = TS_ItemType.COUPON;
    gutscheincode : string; // no english? oh man...
}